import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, mergeMap } from 'rxjs/operators';

import { safeMap } from '@era/stores';
import { DeviceAssignmentHistoryItemDto, SettingsDeviceService } from '@rocksoft/settings-sdk';
import {
  DeviceAssignmentHistoryApiActions,
  DeviceAssignmentHistoryResolverActions,
} from './device-assignment-history.actions';

@Injectable()
export class DeviceAssignmentHistoryEffects {
  private readonly actions$ = inject(Actions);
  private readonly deviceService = inject(SettingsDeviceService);

  deviceAssignmentHistoryRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceAssignmentHistoryResolverActions.historyRequested),
      mergeMap(({ udid }) =>
        safeMap(
          () =>
            this.deviceService.getDeviceAssignmentHistory({ deviceId: udid }).pipe(
              map((response) => {
                validateHistory(response.history);
                return response;
              })
            ),
          (response) => [
            DeviceAssignmentHistoryApiActions.historyLoaded({
              history: response.history,
              deviceId: response.device.id,
            }),
          ],
          (error) => DeviceAssignmentHistoryApiActions.historyLoadedError({ error })
        )
      )
    );
  });
}

function validateHistory(history: DeviceAssignmentHistoryItemDto[]): void {
  for (const item of history) {
    if (item.category && !item.categoryProblem) {
      continue;
    }

    if (!item.category && !item.categoryProblem) {
      continue;
    }

    if (
      !item.category &&
      (item.categoryProblem?.title === 'CategoryDeleted' || item.categoryProblem?.title === 'CategoryNotFound')
    ) {
      continue;
    }

    throw new Error('Invalid device assignment history category state.');
  }
}
